module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-09.f649d7a3.jpg";